import * as $ from 'jquery';
import { apiBaseUrlAdmin } from '../../../constants/url.constant';
import { DefaultService } from '../../common/services/DefaultService';
import { EditPictureModel } from '../../pictures/models/PictureModel';
import { ProductFilterModel } from '../models/ProductModel';

export class AdminProductLineService extends DefaultService {
    private baseUrl = `${apiBaseUrlAdmin}/productLine`;

    public RouteSearch = () => `${this.baseUrl}/search`;
    public search(model: ProductFilterModel): JQueryPromise<any> {
        return $.ajax(this.RouteSearch(), {
            type: 'post',
            data: JSON.stringify(model),
            contentType: 'application/json'
        });
    }

    public RouteCreatePictures = (ownerId: number) => `${this.baseUrl}/createPictures/${ownerId}`;

    public RouteEditPicture = (ownerId: number) => `${this.baseUrl}/editPicture/${ownerId}`;
    public editPicture(ownerId: number, model: EditPictureModel): JQueryPromise<any> {
        return $.ajax(this.RouteEditPicture(ownerId), {
            type: 'put',
            data: JSON.stringify(model),
            contentType: 'application/json'
        });
    }

    public RouteEditPictures = (ownerId: number) => `${this.baseUrl}/editPictures/${ownerId}`;
    public editPictures(ownerId: number, model: EditPictureModel[]): JQueryPromise<any> {
        return $.ajax(this.RouteEditPictures(ownerId), {
            type: 'put',
            data: JSON.stringify(model),
            contentType: 'application/json'
        });
    }

    public RouteDeletePicture = (ownerId: number, id: number) => `${this.baseUrl}/deletePicture/${ownerId}?id=${id}`;
    public deletePicture(ownerId: number, id: number): JQueryPromise<any> {
        return $.ajax(this.RouteDeletePicture(ownerId, id), {
            type: 'delete',
            contentType: 'text/html; charset=utf-8'
        });
    }

    public RouteGetPictures = (ownerId: number) => `${this.baseUrl}/getPictures/${ownerId}`;
    public getPictures(ownerId: number): JQueryPromise<any> {
        return $.ajax(this.RouteGetPictures(ownerId), {
            type: 'get',
            contentType: 'text/html; charset=utf-8'
        });
    }
}